
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1gp1v_ju9sr_5",
  "action-button": "awsui_action-button_1gp1v_ju9sr_9",
  "inline-label": "awsui_inline-label_1gp1v_ju9sr_13"
};
  